import { css } from '@emotion/css';
import { Headline, Text } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

interface SurveyTitleProps {
  showDescription: boolean;
}
const titleStyle = css`
  font-size: 21px;
  line-height: normal;
  font-weight: normal;
`;
export function SurveyTitle({
  showDescription,
}: SurveyTitleProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div>
      <Headline className={titleStyle}>{t('hybrid.surveyTitle')}</Headline>
      {Boolean(showDescription) && <Text>{t('hybrid.surveyDescription')}</Text>}
    </div>
  );
}
